import posthog from 'posthog-js';
import * as FullStory from '@fullstory/browser';

// NOTE: We don't want to initialize PostHog in non-prod mode most of the time, to limit session usage.
const shouldInitializePosthog = process.env.REACT_APP_ENABLE_POSTHOG;

export const initAnalytics = () => {
  if (shouldInitializePosthog) {
    console.info('Initializing PostHog');

    if (!process.env.REACT_APP_POSTHOG_API_KEY) {
      console.error('REACT_APP_POSTHOG_API_KEY is not set');
      return;
    }

    posthog.init(process.env.REACT_APP_POSTHOG_API_KEY, {
      api_host: 'https://us.posthog.com',
    });
  }

  FullStory.init({ orgId: '167FTE' }); // TODO: remove this once we're no longer using FullStory
};

export const captureEvent = (
  eventName: string,
  payload: Record<string, unknown> = {},
) => {
  posthog.capture(eventName, payload);

  FullStory.event(eventName, payload); // TODO: remove this once we're no longer using FullStory
};
